<template>
    <div class="py-4 container-fluid"> 
        <div class="row">
            <div class="mx-auto col-lg-12 col-12">
                <div class="mt-4 card card-body">
                    <div id="print" class="px-1">
                        <h2 class="fs-3 fw-bold mb-5 text-center">
                            SURAT PERNYATAAN
                        </h2>
                        <p>Yang bertanda tangan dibawah ini ;</p>
                        <p>&nbsp;</p>
                        <table class="not-table">
                            <tbody>
                                <tr>
                                    <td class="pa-1 width-10p">Nama</td>
                                    <td class="pa-1 width-1">:</td>
                                    <td class="pa-1">{{ record?.full_name ?? "-" }}</td>
                                </tr>
                                <tr>
                                    <td class="pa-1 width-10p">Alamat</td>
                                    <td class="pa-1 width-1">:</td>
                                    <td class="p-1">{{ `${user?.residential_address}, ${user?.city}, ${user?.province}, ${user?.country}, ${user?.postal_code}` }}</td>
                                </tr>
                                <tr>
                                    <td class="pa-1 width-10p">KTP</td>
                                    <td class="pa-1 width-1">:</td>
                                    <td class="p-1">{{ user?.id_card_number ?? "-" }}</td>
                                </tr>
                                <tr>
                                    <td class="pa-1 width-10p">No. Telepon</td>
                                    <td class="pa-1 width-1">:</td>
                                    <td class="p-1">{{ user?.phone ?? "-" }}</td>
                                </tr>
                            </tbody>
                        </table>
                        <p>&nbsp;</p>
                        <p>
                            Dengan ini menyatakan bahwa saya telah membaca dan memahami Dokumen Perjanjian Pemberian
                            Jasa dan Dokumen Pemberitahuan Adanya Resiko. Saya sepenuhnya menyadari dan menyatakan
                            bahwa Penasihat Berjangka tidak dapat dimintai pertanggungjawaban atas semua resiko dan kerugian
                            yang terjadi akibat Perdagangan Berjangka Komoditi dan Perdagangan Forex dan Gold.
                        </p>
                        <p>&nbsp;</p>
                        <p>
                            Demikian surat pernyataan ini saya buat dan saya tandatangani dengan sadar tanpa ada paksaan dari
                            pihak manapun. 
                        </p>
                        <p>&nbsp;</p>
                        <p>&nbsp;</p>
                        <div class="d-flex justify-content-end">
                            <div>
                                <p>Jakarta, {{ formattedSignDate() }}</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <p>&nbsp;</p>
                                <div>
                                    <p class="text-center">({{ user?.fullname ?? '……………………………………………………………' }})</p>
                                    <p class="text-center">Klien</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-primary mt-5 w-40 mx-auto" @click="generatePDF">Download PDF</button>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import SubscriptionService from "@/services/subscriptions.service.js";
import { ref } from 'vue';
import { toast } from 'vue3-toastify';

const toastId = ref('');
const moment = require('moment');
moment.locale('id');

export default {
    name: "StatmentLetter",
    data() {
        return {
            record: {},
            user: {},
        };
    },
    mounted() {
        this.getRecord()
    },
    methods: {
        showLoading(){
            toastId.value = toast.loading('Please wait...');
        },
        hideLoading(){
            setTimeout(() => {
                toast.remove(toastId.value)
            }, 1000); 
        },
        getRecord(){
            this.showLoading()
            SubscriptionService.get(this.$route.params.id).then(e => {
                this.record = e.data.subscribe_data
                this.user = e.data.user_data
                this.hideLoading()
            }).catch(e => {
                this.showFailed(e.response.data.code_message)           
            });
        },
        formattedSignDate() {
            const date = this.record.transaction_date ? this.record.transaction_date : this.record.updated_at
            return moment(date).format("DD MMMM YYYY");
        },
        async generatePDF() {
            if (typeof window !== 'undefined') {
                const html2pdf = await import('html2pdf.js');
                const element = document.getElementById('print');
                if (!element) {
                    console.error('Element with id "print" not found');
                    return;
                }

                html2pdf.default()
                    .from(element)
                    .set({
                        margin: 1, // Top, Right, Bottom, Left margins
                        filename: `surat-pernyataan.pdf`,
                        image: { type: 'jpeg', quality: 0.98 },
                        html2canvas: { scale: 2 },
                        jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' },
                        pagebreak: { mode: ['avoid-all', 'css', 'legacy'] },
                    })
                    .save();
            } else {
                console.error('Function executed outside the browser environment');
            }
        }
    }
};
</script>